module.exports = __webpack_public_path__ + "static/IAMQS-LOGO-04-2303b4c879bbdf47a711529c8b6e4f24.png";